<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <div class="button-wrapper">
        <a-space>
          <a-button type="primary" @click="$refs.followForm.getList(form.id)" >
            跟进记录
          </a-button>
          <a-button type="primary" @click="$refs.browseForm.getList(form.id)" >
            行为记录
          </a-button>
          <a-button type="primary" @click="$refs.applyForm.getList(form.id)" >
            报名记录
          </a-button>
          <a-button type="primary" @click="$refs.collectForm.getList(form.id)" >
            收藏记录
          </a-button>
          <a-button type="primary" @click="$refs.reportForm.getList(form.id)" >
            报备记录
          </a-button>
          <a-button type="primary" @click="$refs.bankForm.getList(form.id)" >
            银行卡更换记录
          </a-button>
        </a-space>
      </div>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="姓名" prop="realName" >
            <a-input v-model="form.realName" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="手机号" prop="mobile">
            <a-input v-model="form.mobile" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-tabs v-model="activeKey">
        <a-tab-pane key="1" tab="基本信息">
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="头像" prop="avatar" >
                <a-upload
                  :customRequest="fileUploadRequest"
                  list-type="picture-card"
                  :showUploadList="true"
                  :beforeUpload="beforeUpload"
                  @change="handleChange">
                  <img v-if="form.avatar" :src="form.avatar" alt="图片" style="height:104px;max-width:300px"/>
                  <div v-else>
                    <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
                    <div class="ant-upload-text">上传</div>
                  </div>
                </a-upload>
                <a-button v-if="form.avatar" @click="handlePreview1(form.avatar)">
                  <a-icon :type="'eye'" />
                  预览
                </a-button>
                <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                  <img alt="example" style="width: 100%" :src="previewUrl"/>
                </a-modal>
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="简历" prop="resumeUrl">
                <div v-if="form.resumeUrl">
                  <img src="@/views/biz/user/modules/png/pdf.png" style="height:104px;max-width:300px" @click="handlePreview"/>
                </div>
                <div v-else>
                  {{ '无' }}
                </div>
                <a-upload
                  :customRequest="fileUploadRequest"
                  list-type="text"
                  :showUploadList="false"
                  :beforeUpload="beforeUpload1"
                  @change="handleChange1">
                  <a-button v-if="!form.resumeUrl">
                    <a-icon type="upload"/>
                    上传
                  </a-button>
                  <a-button v-else>
                    <a-icon type="upload"/>
                    重新上传
                  </a-button>
                </a-upload>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="出生年月" prop="birthday" >
                <a-date-picker
                  style="width: 40%"
                  v-model="form.birthday"
                  valueFormat="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  allow-clear disabled/>
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="身份证号" prop="idCard">
                <a-input v-model="form.idCard" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="微信号" prop="wxCode" >
                <a-input v-model="form.wxCode" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="民族" prop="nation" >
                <a-input v-model="form.nation" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="学历" prop="education" >
                <a-select v-model="form.education" placeholder="请选择">
                  <a-select-option :value="1">高中</a-select-option>
                  <a-select-option :value="2">大专</a-select-option>
                  <a-select-option :value="3">本科</a-select-option>
                  <a-select-option :value="4">研究生</a-select-option>
                  <a-select-option :value="5">博士生</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="性别" prop="sex">
                <a-select v-model="form.sex" placeholder="请选择">
                  <a-select-option :value="0">保密</a-select-option>
                  <a-select-option :value="1">男</a-select-option>
                  <a-select-option :value="2">女</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="身高（CM）" prop="height">
                <a-input-number :step="0.01" v-model="form.height" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="意向岗位" prop="workId" >
                <a-select v-model="form.workId" placeholder="请选择">
                  <a-select-option v-for="(work,index) in workTypeList" :key="index" :value="work.id">{{ work.name }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="体重（kg）" prop="weight" >
                <a-input-number :step="0.01" v-model="form.weight" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="是否有纹身" prop="hasTattoo">
                <a-select v-model="form.hasTattoo" placeholder="请选择">
                  <a-select-option :value="0">否</a-select-option>
                  <a-select-option :value="1">是</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="是否残疾" prop="isDisability" >
                <a-select v-model="form.isDisability" placeholder="请选择">
                  <a-select-option :value="0">否</a-select-option>
                  <a-select-option :value="1">是</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="残疾详情" prop="disabilityDetail">
                <a-textarea :row="3" v-model="form.disabilityDetail" placeholder="请输入" :disabled="form.isDisability == 0" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="户籍省" prop="nativePlaceProvince" >
                <a-input v-model="form.nativePlaceProvince" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="户籍市" prop="nativePlaceCity">
                <a-input v-model="form.nativePlaceCity" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="户籍县" prop="nativePlaceCounty" >
                <a-input v-model="form.nativePlaceCounty" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="户籍详细地址" prop="nativePlaceAddress">
                <a-input v-model="form.nativePlaceAddress" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="定位省" prop="province" >
                <a-input v-model="form.province" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="定位市" prop="city">
                <a-input v-model="form.city" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="定位县" prop="county" >
                <a-input v-model="form.county" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="定位详细地址" prop="address">
                <a-input v-model="form.address" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="年龄" prop="age" >
                <a-input v-model="form.age" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="求职意向" prop="jobIntention">
                <a-textarea :row="3" v-model="form.jobIntention" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="标签（专员）" prop="oneTagIds" >
                <a-select v-model="oneTagIds" mode="multiple" placeholder="请选择">
                  <a-select-option showSearch v-for="(tag,index) in tagList" :key="index" :value="tag.id">{{ tag.name }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="标签（推荐官）" prop="twoTagIds">
                <a-select v-model="twoTagIds" mode="multiple" placeholder="请选择">
                  <a-select-option showSearch v-for="(tag,index) in tagList" :key="index" :value="tag.id">{{ tag.name }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="身份证人像面" prop="idCardFront" >
                <a-upload
                  :customRequest="fileUploadRequest"
                  list-type="picture-card"
                  :showUploadList="false"
                  :beforeUpload="beforeUpload"
                  @change="handleChange2">
                  <img v-if="form.idCardFront" :src="form.idCardFront" alt="图片" style="height:200px;max-width:300px"/>
                  <div v-else>
                    <a-icon :type="uploadLoading2 ? 'loading' : 'plus'"/>
                    <div class="ant-upload-text">上传</div>
                  </div>
                </a-upload>
                <a-button v-if="form.idCardFront" @click="handlePreview1(form.idCardFront)">
                  <a-icon :type="'eye'" />
                  预览
                </a-button>
                <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                  <img alt="example" style="width: 100%" :src="previewUrl"/>
                </a-modal>
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="身份证国徽面" prop="idCardReverse">
                <a-upload
                  :customRequest="fileUploadRequest"
                  list-type="picture-card"
                  :showUploadList="false"
                  :beforeUpload="beforeUpload"
                  @change="handleChange3">
                  <img v-if="form.idCardReverse" :src="form.idCardReverse" alt="图片" style="height:200px;max-width:300px"/>
                  <div v-else>
                    <a-icon :type="uploadLoading3 ? 'loading' : 'plus'"/>
                    <div class="ant-upload-text">上传</div>
                  </div>
                </a-upload>
                <a-button v-if="form.idCardReverse" @click="handlePreview1(form.idCardReverse)">
                  <a-icon :type="'eye'" />
                  预览
                </a-button>
                <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                  <img alt="example" style="width: 100%" :src="previewUrl"/>
                </a-modal>
              </a-form-model-item>
            </a-col>
            <a-modal :open="previewVisible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewUrl" />
            </a-modal>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="2" tab="来源信息" force-render>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="首次登录注册时间" prop="createTime" >
                <a-input v-model="form.createTime" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="邀请所属" prop="inviteUserNickname" >
                <a-input v-model="form.inviteUserNickname" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="来源渠道" prop="sourceChannelName" >
                <a-input v-model="form.sourceChannelName" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="来源类型" prop="sourceType">
                <a-select v-model="form.sourceType" placeholder="请选择" disabled >
                  <a-select-option :value="1">平台分享</a-select-option>
                  <a-select-option :value="2">招聘专员分享</a-select-option>
                  <a-select-option :value="3">推荐官分享</a-select-option>
                  <a-select-option :value="4">推荐官专员分享</a-select-option>
                  <a-select-option :value="5">驻场客服分享</a-select-option>
                  <a-select-option :value="6">其他</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="招聘专员" prop="topNickname">
                <a-select v-model="form.topUserId" placeholder="请选择" optionFilterProp="children" showSearch >
                  <a-select-option v-for="(topUser,index) in topUserList" :key="index" :value="topUser.id">
                    {{ topUser.nickname }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="推荐官" prop="referralsNickname" >
                <a-select v-model="form.referralsUserId" placeholder="请选择" optionFilterProp="children" showSearch >
                  <a-select-option v-for="(referralsUser,index) in referralsUserList" :key="index" :value="referralsUser.id">
                    {{ referralsUser.nickname }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="推荐官专员" prop="topReferralsNickname">
                <a-select v-model="form.topReferralsUserId" placeholder="请选择" optionFilterProp="children" showSearch  >
                  <a-select-option v-for="(topReferralsUser,index) in topReferralsUserList" :key="index" :value="topReferralsUser.id">
                    {{ topReferralsUser.nickname }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="3" tab="银行卡信息" force-render>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="银行卡号" prop="bankNo" >
                <a-input v-model="form.bankNo" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="银行名称" prop="bankName">
                <a-input v-model="form.bankName" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="开户行" prop="bankSubName" >
                <a-input v-model="form.bankSubName" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="开户地" prop="bankSubName" >
                <a-input v-model="form.bankAddress" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="银行预留手机号" prop="bankMobile" >
                <a-input v-model="form.bankMobile" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="真实姓名" prop="bankRealName">
                <a-input v-model="form.bankRealName" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="4" tab="工作信息">
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="入职公司" prop="entryCompanyName" >
                <a-input v-model="form.entryCompanyName" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="入职岗位" prop="entryPostName" >
                <a-input v-model="form.entryPostName" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="入职工种" prop="entryWorkName">
                <a-input v-model="form.entryWorkName" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="入职时间" prop="entryDate" >
                <a-input v-model="form.entryDate" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="面试时间" prop="interviewTime">
                <a-input v-model="form.interviewTime" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="离职时间" prop="dimissionTime" >
                <a-input v-model="form.dimissionTime" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
      <follow-form ref="followForm"/>
      <browse-form ref="browseForm"/>
      <bank-form ref="bankForm"/>
      <apply-form ref="applyForm"/>
      <collect-form ref="collectForm"/>
      <report-form ref="reportForm"/>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUser, addUser, updateUser,queryUserByType } from '@/api/biz/user'
// import VueOfficePdf from '@vue-office/pdf'
// import pdf from 'vue-pdf'
import { ref } from 'vue';
import UploadFileToOSS from '@/utils/upload-file-to-oss'
import { listTag } from '@/api/user/tag'
import { listWork } from '@/api/user/work'
import ImgForm from '@/views/user/rule/modules/ImgForm'
import FollowForm from './FollowForm'
import BrowseForm from './BrowseForm'
import BankForm from './BankForm'
import ApplyForm from './ApplyForm'
import CollectForm from './CollectForm'
import ReportForm from './ReportForm'

export default {
  name: 'CreateForm',
  props: {
    sexOptions: {
      type: Array,
    },
    isNoticeOptions: {
      type: Array,
    },
    statusOptions: {
      type: Array,
    }
  },
  components: {
    FollowForm,
    BrowseForm,
    BankForm,
    ApplyForm,
    CollectForm,
    ReportForm,
    ImgForm,
    // pdf
    // VueOfficePdf
  },
  data () {
    return {
      submitLoading: false,
      uploadLoading: false,
      uploadLoading1: false,
      uploadLoading2: false,
      uploadLoading3: false,
      formTitle: '',
      activeKey: '1',
      fileList: [],
      tagList: [],
      oneTagIds: [],
      twoTagIds: [],
      workTypeList: [],
      topUserList: [],
      referralsUserList: [],
      topReferralsUserList: [],
      district: null,
      // 表单参数
      form: {
        id: null,
        mobile: null,
        email: null,
        password: null,
        resumeUrl: null,
        avatar: null,
        nickname: null,
        sex: null,
        birthday: null,
        userSign: null,
        invitationCode: null,
        bankRealName: null,
        isNotice: null,
        status: null,
        createTime: null,
        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      previewUrl: null,
      previewTitle: null,
      previewVisible: false,
      numPages: null,
      rules: {
        mobile: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
        // realName: [
        //   { required: true, message: '不能为空', trigger: 'blur' }
        // ],
        // wxCode: [
        //   { required: true, message: '不能为空', trigger: 'blur' }
        // ],
        // idCard: [
        //   { required: true, message: '不能为空', trigger: 'blur' }
        // ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
// 计算pdf页码总数
//     getNumPages() {
//       const loadingTask = pdf.createLoadingTask(this.form.resumeUrl)
//       loadingTask.promise.then(pdf => {
//         this.numPages = pdf.numPages
//       }).catch(err => {
//         console.error('pdf 加载失败', err);
//       })
//     },
    async handlePreview() {
      // this.previewUrl = ref(url)
      // this.previewVisible = true
      // this.getNumPages()
      window.open(this.form.resumeUrl, '_blank');
    },
    async handlePreview1(url) {
      // if (!file.url && !file.preview) {
      //   file.preview = await getBase64(file.originFileObj);
      // }
      debugger
      this.previewUrl = url
      this.previewVisible = true
    },
    handleCancel() {
      this.previewVisible = false
    },
    rendered() {
      console.log('渲染完成')
    },
    listUserByType(type, nickname) {
      const param = { type: type , nickname: nickname}
      queryUserByType(param).then(response => {
        if (type === 1) {
          this.topUserList = response.data
        }
        if (type === 2) {
          this.referralsUserList = response.data
        }
        if (type === 3) {
          this.topReferralsUserList = response.data
        }
      })
    },
    queryWorkList() {
      const param = {}
      listWork(param).then(response => {
        this.workTypeList = response.data
      })
    },
    queryTagList() {
      const param = { type: 3 }
      listTag(param).then(response => {
        this.tagList = response.data
      })
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true
        return
      }
      if (info.file.status === 'done') {
        this.uploadLoading = false
        this.form.avatar = info.file.originFileObj.ossUrl
        this.fileList = [info.file];
      } else if (info.file.status === 'removed') {
        // 文件被删除
        this.form.avatar = '';
        this.fileList = [];
      }
    },
    handleChange2(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading2 = true
        return
      }
      if (info.file.status === 'done') {
        this.uploadLoading2 = false
        this.form.idCardFront = info.file.originFileObj.ossUrl
        this.fileList = [info.file];
      } else if (info.file.status === 'removed') {
        // 文件被删除
        this.form.idCardFront = '';
        this.fileList = [];
      }
    },
    handleChange3(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading3 = true
        return
      }
      if (info.file.status === 'done') {
        this.uploadLoading3 = false
        this.form.idCardReverse = info.file.originFileObj.ossUrl
        this.fileList = [info.file];
      } else if (info.file.status === 'removed') {
        // 文件被删除
        this.form.idCardReverse = '';
        this.fileList = [];
      }
    },
    handleChange1(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading1 = true
        return
      }
      if (info.file.status === 'done') {
        this.uploadLoading1 = false
        this.form.resumeUrl = info.file.originFileObj.ossUrl
      }
    },
    fileUploadRequest(fileInfo) {
      this.uploadLoading = true
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          // Log.info('multi-img-upload', res);
          const ossUrl = res[0].url
          fileInfo.file.ossUrl = ossUrl
          fileInfo.file.ossName = ossUrl
          fileInfo.onSuccess()
        }
      })
    },
    beforeUpload: function (file) {
      return new Promise((resolve, reject) => {
        if (file.size > 5 * 1024 * 1000) {
          this.$message.warning('图片大小不能超过5M')
          return reject(false)
        }

        var fileType = file.type
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片')
          return reject(false)
        }
        resolve(true)
      })
    },
    beforeUpload1: function (file) {
      return new Promise((resolve, reject) => {
        var fileType = file.type
        debugger
        if (fileType.indexOf('pdf') < 0) {
          this.$message.warning('请上传PDF文件')
          return reject(false)
        }
        resolve(true)
      })
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.tagList = []
      this.oneTagIds = []
      this.twoTagIds = []
      this.workTypeList = []
      this.topUserList = []
      this.referralsUserList = []
      this.topReferralsUserList = []
      this.form = {
        id: null,
        mobile: null,
        email: null,
        password: null,
        avatar: null,
        nickname: null,
        sex: null,
        birthday: null,
        resumeUrl: null,
        userSign: null,
        invitationCode: null,
        isNotice: null,
        status: null,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.queryTagList()
      this.queryWorkList()
      this.listUserByType(1)
      this.listUserByType(2)
      this.listUserByType(3)
      this.formType = 2
      const id = row ? row.id : ids
      getUser({ 'id': id }).then(response => {
        this.form = response.data
        this.district = this.form.province + '' + this.form.city + '' + this.form.county
        if (this.form.oneTagIds) {
          this.oneTagIds = this.form.oneTagIds.split(',')
        }
        if (this.form.twoTagIds) {
          this.twoTagIds = this.form.twoTagIds.split(',')
        }
        this.open = true
        this.formTitle = '客户查看/编辑'
      })
    },

    /** 修改按钮操作 */
    handleUpdate1 (row, ids) {
      this.reset()
      this.queryTagList()
      this.queryWorkList()
      this.listUserByType(1)
      this.listUserByType(2)
      this.listUserByType(3)
      this.formType = 2
      const id = row ? row.userId : ids
      getUser({ 'id': id }).then(response => {
        this.form = response.data
        this.district = this.form.province + '' + this.form.city + '' + this.form.county
        if (this.form.oneTagIds) {
          this.oneTagIds = this.form.oneTagIds.split(',')
        }
        if (this.form.twoTagIds) {
          this.twoTagIds = this.form.twoTagIds.split(',')
        }
        this.open = true
        this.formTitle = '客户查看/编辑'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.form.oneTagIds = this.oneTagIds.join(',')
      this.form.twoTagIds = this.twoTagIds.join(',')
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateUser(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addUser(this.form).then(response => {
              this.$message.success(
                '新增成功',
                35
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .button-wrapper{
    display: flex;
    justify-content: flex-end;
  }
  .pdf-container {
    width: 100%;
    height: 800px;
  }
</style>
